import React from 'react';
import { Text } from '@consta/uikit/Text';
import { Button } from '@consta/uikit/Button';

// Styles
import cn from 'classnames/bind';
import styles from './styles.styl';
import { IconCheck } from '@consta/uikit/IconCheck';
import { PublishTestText, PublishTestTitle } from 'src/config/config';
import { useHistory } from 'react-router-dom';
import { PrivateRoutesEnum } from 'src/utils/router';
import QRCodeLink from 'src/components/QRCodeLink';
import { storagePublishUrl } from 'src/utils/storage';

const cx = cn.bind(styles);

export interface PublishTestProps {}

export const PublishTest: React.FC<PublishTestProps> = () => {
  const history = useHistory();

  return (
    <div className={cx('PublishTest')}>
      <div className={cx('PublishTest__iconContainer')}>
        <IconCheck className={cx('PublishTest__icon')} />
      </div>
      <Text className={cx('PublishTest__title')} size="xl">
        {PublishTestTitle}
      </Text>
      <Text className={cx('PublishTest__description')} size="m">
        {PublishTestText}
      </Text>
      <QRCodeLink />
      <div className={cx('PublishTest__footer')}>
        <Button
          onClick={() => history.push(PrivateRoutesEnum.DASHBOARD)}
          size="m"
          view="secondary"
          label="Закрыть"
          className={cx('PublishTest__close')}
        />
        <Button
          onClick={() =>
            window.open(`/walkthrough/${storagePublishUrl()}/draft`)
          }
          view="secondary"
          label="Предпросмотр"
          className={cx('PublishTest__close')}
        />
      </div>
    </div>
  );
};
